import { useContext, useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { StickyComponentContext } from './StickyComponentContext.js';

export const useStickyComponent = ({ shouldStick, removalDelayMs = 0 }) => {
  const [showSticky, setShowSticky] = useState(false);
  const [stickyUnmounting, setStickyUnmounting] = useState(false);
  const context = useContext(StickyComponentContext);

  const { ref, inView } = useInView({ initialInView: true });
  const timeout = useRef();

  useEffect(() => {
    if (showSticky && !shouldStick?.(inView, context)) {
      setStickyUnmounting(true);
      timeout.current = setTimeout(() => {
        setShowSticky(false);
        setStickyUnmounting(false);
      }, removalDelayMs);
      return () => {
        clearTimeout(timeout.current);
        timeout.current = null;
      };
    }
    if (!timeout.current && shouldStick(inView, context)) {
      setShowSticky(true);
    }
  }, [inView, showSticky, context, shouldStick, removalDelayMs]);

  return { inView, showSticky, stickyUnmounting, ref };
};
